// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/monitoring/v2/monitoring_config_service.proto (package ai.h2o.mlops.monitoring.v2, syntax proto3)
/* eslint-disable */

import { RPC } from "../../../../../runtime";

/**
 * Request message for GenerateAggregatorConfig
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.GenerateAggregatorConfigRequest
 */
export type GenerateAggregatorConfigRequest = {
/**
 * Required. The resource name.
 * Format: `workspaces/{workspace}/deployments/{deployment}/experiments/{experiment}` or
 *         `workspaces/{workspace}/jobs/{job}/experiments/{experiment}`
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for GenerateAggregatorConfig
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.GenerateAggregatorConfigResponse
 */
export type GenerateAggregatorConfigResponse = {
/**
 * Aggregator config in yaml format
 *
 * @generated from field: string aggregator_config = 1;
 */
aggregatorConfig?: string;
}
;
/**
 * Generate monitoring aggregator config for given experiment.
 *
 * @generated from rpc ai.h2o.mlops.monitoring.v2.MonitoringConfigService.GenerateAggregatorConfig
 */
export const MonitoringConfigService_GenerateAggregatorConfig = new RPC<GenerateAggregatorConfigRequest,GenerateAggregatorConfigResponse>("GET", "/v2/{name=workspaces/*/deployments/*/experiments/*}:generateAggregatorConfig");
